export const fetchSection = (url) =>
  fetch(url)
    .then((res) => res.text())
    .then((html) =>
      new DOMParser()
        .parseFromString(html, "text/html")
        .querySelector(".shopify-section")
    );


export class ShopifyCartError {
  static async create(error, module) {
    const instance = new this(error, module)

    return instance.render(instance.message)
  }

  constructor(error, module) {
    this.message =
      error.description !== null ? error.description : error.message
    this.status = error.status

    this.module = module
  }

  render(message) {
    const errors = document.querySelector(this.module.selectors.errors)

    const clone = document
      .querySelector(this.module.selectors.errorTemplate)
      .content.cloneNode(true)

    clone.querySelector(this.module.selectors.errorText).textContent = message

    errors.appendChild(clone)
  }
}

class QuantityAdjuster extends HTMLElement {
  constructor() {
    super()

    this.input = this.querySelector('input')
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(button =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    )
  }

  onButtonClick(e) {
    e.preventDefault()
    const button = e.target.closest('button')
    const previousValue = this.input.value

    button.name === 'plus' ? this.input.stepUp() : this.input.stepDown()
    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent)
    }
  }
}

customElements.define('quantity-adjuster', QuantityAdjuster)

class ShopifyCart extends HTMLElement {
  constructor() {
    super();

    window.shopifyCart = this;

    this.selectors = {
      form: '[data-shopify-cart-form]',
      cartItem: '[data-cart-item]',
      quantity: '[data-shopify-cart-quantity]',
      remove: '[data-shopify-cart-remove]',
      notify: '[data-shopify-cart-notify]',
      errors: '[data-shopify-cart-errors]',
      errorItem: '[data-shopify-cart-error]',
      errorText: '[data-shopify-cart-error-text]',
      errorClose: '[data-shopify-cart-error-close]',
      errorTemplate: '[data-shopify-cart-error-template]',
      productQuickview: '[data-product-quick-view]',
      subscriptionOptions: '[name="subscription_options"]',
      activeSubscriptionOptions: '[name="active_subscription_options"]',
      addSubscription: '[data-shopify-cart-add-subscription]'
    };

    this.features = {
      shipping: JSON.parse(this.dataset.cartShippingProgressBarEnable),
    };


    this.initialse();
  }

  async initialse() {
    this.cartState = JSON.parse(this.querySelector('script').textContent);

    this.addEventListener('click', this.onRemoveClick.bind(this));
    this.addEventListener('change', this.onQuantityUpdate.bind(this));
    this.addEventListener('click', this.onCartErrorClick.bind(this));
    this.addEventListener('click', this.onAddSubscription.bind(this));
    this.addEventListener('change', this.onSubscriptionSelect.bind(this));
    this.addEventListener('change', this.onActiveSubscriptionSelect.bind(this));
    document.addEventListener('submit', this.onFormSubmit.bind(this));
  }

  onAddSubscription(e) {
    if (e.target.closest(this.selectors.addSubscription) == null) return;

    const item = e.target.closest(this.selectors.cartItem);

    item.querySelector(this.selectors.subscriptionOptions).selectedIndex = 0;

    item
      .querySelector(this.selectors.subscriptionOptions)
      .parentNode.classList.add('active');

    item
      .querySelector(this.selectors.addSubscription)
      .classList.remove('active');
  }

  async onSubscriptionSelect(e) {
    if (e.target.closest(this.selectors.subscriptionOptions) == null) return;

    const item = e.target.closest(this.selectors.cartItem);

    if (e.target.value === 'onetime') {
      item
        .querySelector(this.selectors.subscriptionOptions)
        .parentNode.classList.remove('active');

      item
        .querySelector(this.selectors.addSubscription)
        .classList.add('active');
    } else {
      this.loading = true;

      const quantityEl = item.querySelector(this.selectors.quantity);
      const quantity = quantityEl ? parseInt(quantityEl.value) : 1;

      this.render(
        await this.updateItem({
          line: Number(item.dataset.index),
          quantity,
          selling_plan: Number(e.target.value)
        })
      );
    }
  }

  async onActiveSubscriptionSelect(e) {
    if (e.target.closest(this.selectors.activeSubscriptionOptions) == null)
      return;

    e.preventDefault();

    this.loading = true;

    const item = e.target.closest(this.selectors.cartItem);

    const quantityEl = item.querySelector(this.selectors.quantity);
    const quantity = quantityEl ? parseInt(quantityEl.value) : 1;

    this.render(
      await this.updateItem({
        line: Number(item.dataset.index),
        quantity,
        selling_plan:
          e.target.value === 'onetime' ? null : Number(e.target.value)
      })
    );
  }

  async onFormSubmit(e) {
    if (!e.target.matches(this.selectors.form)) return;

    e.preventDefault();

    if (
      !document.body.classList.contains('template-cart') &&
      window.drawers.activeDrawer !== 'cart'
    ) {
      window.drawers.activeDrawer = 'cart';
    }

    this.loading = true;

    this.render(await this.addItem(e));
  }

  async onQuantityUpdate(e) {
    if (!e.target.matches(this.selectors.quantity)) return;

    e.preventDefault();

    this.loading = true;

    const item = e.target.closest(this.selectors.cartItem);

    const quantityEl = item.querySelector('[name="quantity"]');
    const quantity = quantityEl ? parseInt(quantityEl.value) : 1;
    this.render(
      await this.updateItem({ line: Number(item.dataset.index), quantity })
    );
  }

  async onRemoveClick(e) {
    if (e.target.closest(this.selectors.remove) === null) return;

    e.preventDefault();

    this.loading = true;

    const item = e.target.closest(this.selectors.cartItem);

    this.render(
      await this.updateItem({ line: Number(item.dataset.index), quantity: 0 })
    );
  }

  async addItem(e) {
    const formData = new FormData(e.target);

    formData.append(
      'sections',
      this.getSectionsToRender().map((section) => section.section)
    );

    formData.append('sections_url', window.location.pathname);

    return fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: {
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    })
      .then(async (response) => {
        if (response.status !== 200) {
          throw response;
        }

        this.cartState = await this.getCart();
        return await response.json();
      })
      .catch((err) => {
        this.handleCartError(err);
      });
  }

  async updateItem(item) {
    return fetch(window.routes.cart_change_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript'
      },
      body: JSON.stringify({
        ...item,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      })
    })
      .then(async (response) => {
        if (response.status !== 200) {
          throw response;
        }

        return await response.json();
      })
      .catch((err) => {
        this.handleCartError(err);
      });
  }

  async updateCart(update) {
    return fetch(window.routes.cart_update_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript'
      },
      body: JSON.stringify({
        ...update,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      })
    })
      .then(async (response) => {
        if (response.status !== 200) {
          throw response;
        }

        return await response.json();
      })
      .catch((err) => {
        this.handleCartError(err);
      });
  }

  async getCart() {
    return fetch('/cart.js', {
      method: 'GET',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json'
      }
    }).then(async (response) => {
      const responseJson = await response.json();
      return responseJson;
    });
  }

  async handleCartError(err) {
    this.loading = false;
    this.error = true;

    if ('json' in err) {
      return ShopifyCartError.create(await err.json(), this);
    }

    return ShopifyCartError.create(err, this);
  }

  onCartErrorClick(e) {
    if (e.target.closest(this.selectors.errorClose) === null) return;

    this.destroyErrors();
  }

  async destroyErrors() {
    this.error = false;

    this.querySelectorAll('[data-shopify-cart-error]').forEach((error) =>
      error.remove()
    );

    this.render(
      await this.updateCart({
        attributes: { gift_wrap: true }
      })
    );
  }

  async render(state, sections = this.getSectionsToRender()) {
    if (!state) return;
    sections.forEach((section) => {
      const element = document.querySelector(section.selector);

      if (element) {
        element.innerHTML = this.getSectionInnerHTML(
          state.sections[section.section],
          section.sectionSelector ? section.sectionSelector : '.shopify-section'
        );
      }
    });

    this.loading = false;
  }

  getSectionsToRender() {
    let sections = [
      {
        section: 'cart-items',
        selector: '[data-cart-items]'
      },
      {
        section: 'cart-count',
        selector: '[data-cart-count]'
      },
      {
        section: 'cart-totals',
        selector: '[data-cart-totals]'
      }
    ];

    if (this.features.shipping) {
      sections.push({
        section: 'cart-shipping-progress-bar',
        selector: '[data-cart-shipping-progress-bar]'
      });
    }

    return sections;
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  set loading(val) {
    this.classList.toggle('loading', val);
  }

  set error(val) {
    this.classList.toggle('error', val);
  }
}

if (!customElements.get('shopify-cart')) {
  customElements.define('shopify-cart', ShopifyCart);
}
